import React, { useRef, useEffect } from 'react';
import { isValidFuntion } from '../control/Constant';
import { AoPaymentReturnUrl, AoPaymentUrl } from '../network/url';
import { getLoggedUserId, setLoggedUserId } from '../network/auditFields';

const PaymentGateWay = ({ orderIdData, primaryUserId, isSubsPay, queryData }) => {
    const refFormBtn = useRef();

    const loginUserId = getLoggedUserId();

    useEffect(() => {
        if (isValidFuntion(orderIdData?.orderId)) {
            setLoggedUserId(loginUserId);

            if (queryData?.paymnetFromIntake === "true" || queryData?.paymnetFromEventCoordinator === "true") {
                sessionStorage.setItem(
                    "queryData",
                    JSON.stringify({
                        ...queryData,
                        ...(loginUserId ? { loggedUserId: loginUserId, UpsertedBy: loginUserId } : {}),
                    })
                );
                sessionStorage.setItem("isCameFromPaymentGateWay", "true");
            }
            if (queryData?.paymnetFromEventCoordinator == 'true') {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("moConId");
                sessionStorage.setItem("moConId", encodedData);
            }

            refFormBtn.current.submit();
        }
    }, [orderIdData?.orderId]);

    const isLocalhost = window.location.hostname === 'localhost';
    const returnUrlAfterPayment = isLocalhost ? "http://localhost:3000" : AoPaymentReturnUrl;

    return (
        <>
            <form action={`${AoPaymentUrl}Catalog/PaymentRequest`} method="post" ref={refFormBtn}>
                <div>
                    <input type="hidden" name="AppState" id="AppState" value={"_appState"} />
                    <input type="hidden" name="ReturnUrl" id="ReturnUrl" value={returnUrlAfterPayment} />
                    <input type="hidden" name="UserId" value={primaryUserId} />
                    <input type="hidden" name="OrderId" value={orderIdData?.orderId} />
                    <input type="hidden" name="PaymentType" value={"Card"} />
                    {loginUserId && (
                        <>
                            <input type="hidden" name="createdBy" value={loginUserId} />
                            <input type="hidden" name="UpsertedBy" value={loginUserId} />
                        </>
                    )}
                </div>
            </form>
        </>
    );
};

export default PaymentGateWay;